interface CachedData<T> {
  data: T;
  timestamp: number;
}

export class CacheService {
  private static readonly CACHE_DURATION = 10 * 60 * 1000; // 10 minutes in milliseconds
  private static readonly STORAGE_PREFIX = 'cache_';

  static async get<T>(storageKey: string, resourceType: string, fetchData: (id: string) => Promise<T>): Promise<T> {
    const cacheKey = `${this.STORAGE_PREFIX}${resourceType}_${storageKey}`;
    const cached = localStorage.getItem(cacheKey);

    if (cached) {
      const parsed: CachedData<T> = JSON.parse(cached);
      const now = Date.now();
        
      // Return cached data if it's less than 10 minutes old
      if (now - parsed.timestamp < this.CACHE_DURATION) {
        return parsed.data;
      }
    }

    // Fetch new data if no valid cache
    try {
      const data = await fetchData(storageKey);
      
      // Store in local storage with timestamp
      const cacheData: CachedData<T> = {
        data,
        timestamp: Date.now()
      };
      localStorage.setItem(cacheKey, JSON.stringify(cacheData));
      
      return data;
    } catch (error) {
      console.error('Data fetch failed:', error);
      throw error;
    }
  }
  
  static clear(resourceType: string, storageKey?: string) {
    localStorage.removeItem(`${this.STORAGE_PREFIX}${resourceType}_${storageKey || ''}`);
  }
}